import { touchWatchlistActivity } from './service';

// Best effort, never navigates: a lost touch only shortens the inactivity clock by one visit.
export const recordWatchlistActivity = () => touchWatchlistActivity({ redirectOnSessionExpiry: false }).catch(() => {});
